import React from 'react';
import { useResizeObserver } from '@rescui/use-resize-observer';
const MenuWrapper = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children,
    onHeightUpdate
  } = _ref;
  useResizeObserver(ref, entry => onHeightUpdate(entry.target.offsetHeight));
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    "data-rs-internal": 'dropdown-menu__menu-wrapper'
  }, children);
});
MenuWrapper.displayName = 'MenuWrapper';
export { MenuWrapper };
